<template>
  <el-affix :offset="20" style="background:#F5FCFF;">
    <el-input
      v-if="sidebarActive === 'privacy-policy'"
      :prefix-icon="Search"
      class="mx-24 my-12"
      placeholder="Ketik untuk mencari"
      v-model="searchPrivacy"
      style="max-width: 260px;" />
    <el-input
      v-else
      :prefix-icon="Search"
      class="mx-24 my-12"
      placeholder="Ketik untuk mencari"
      v-model="search"
      style="max-width: 260px;" />
  </el-affix>
  <el-aside>
    <el-scrollbar class="pb-24">
      <el-menu
        v-if="sidebarActive === 'documentation'"
        :collapse="isCollapse"
        :default-openeds="activeMenu"
        class="el-menu-vertical-demo"
        background-color="#F5FCFF"
        active-text-color="#1685C7">
        <template v-if="filterMenu.length > 0">
          <el-sub-menu v-for="(items, key) in filterMenu" :key="key" :index="items.index">
            <template #title>
              <div class="main-sidebar__menu-icon"><i class="bi bi-check-square"></i></div>
              <span class="main-sidebar__menu-title">{{ items.name }}</span>
            </template>
            <el-divider class="mt-0 mb-0"></el-divider>
            <el-menu-item
              v-for="(item, key) in items.sub_menu"
              :key="key"
              :index="item.index"
              class="sub-menu-container">
              <template #title>
                <router-link :to="item.url" class="main-sidebar__sub-menu-title">{{ item.sub_name}}</router-link>
              </template>
            </el-menu-item>
          </el-sub-menu>
        </template>
        <template v-else>
          <div class="found-menu">
            <span class="font-14 color-gray-dark">{{ $t('label.no_resources_found') }}</span>
          </div>
        </template>
      </el-menu>
      <el-menu
        v-if="sidebarActive === 'console'"
        :collapse="isCollapse"
        :default-openeds="['app-management']"
        default-active="app-management"
        class="el-menu-vertical-demo"
        background-color="#F5FCFF"
        active-text-color="#1685C7">
        <el-sub-menu v-for="(items, key) in dataMenuConsole" :key="key" :index="items.index">
          <template #title>
            <div class="main-sidebar__menu-icon"><i class="bi bi-chat-square-heart"></i></div>
            <span class="main-sidebar__menu-title">{{ items.name }}</span>
          </template>
          <el-divider class="mt-0 mb-0"></el-divider>
          <el-menu-item
            v-for="(item, key) in items.sub_menu"
            :key="key"
            :index="item.index"
            class="sub-menu-container">
            <template #title>
              <router-link :to="item.url" class="main-sidebar__sub-menu-title">{{ item.sub_name}}</router-link>
            </template>
          </el-menu-item>
        </el-sub-menu>
      </el-menu>
      <el-menu
        v-if="sidebarActive === 'documentation'"
        :collapse="isCollapse"
        :default-openeds="['webhook']"
        default-active="webhook"
        class="el-menu-vertical-demo"
        background-color="#F5FCFF"
        active-text-color="#1685C7">
        <template v-if="dataMenuWebhook.length > 0">
          <el-sub-menu v-for="(items, key) in dataMenuWebhook" :key="key" :index="items.index">
            <template #title>
              <div class="main-sidebar__menu-icon"><i class="bi bi-chat-square-heart"></i></div>
              <span class="main-sidebar__menu-title">{{ items.name }}</span>
            </template>
            <el-divider class="mt-0 mb-0"></el-divider>
            <el-menu-item
              v-for="(item, key) in items.sub_menu"
              :key="key"
              :route="item.url"
              :index="item.index"
              class="sub-menu-container">
              <template #title>
                <router-link :to="item.url" class="main-sidebar__sub-menu-title">{{ item.sub_name}}</router-link>
              </template>
            </el-menu-item>
          </el-sub-menu>
        </template>
        <template v-else>
          <div class="found-menu">
            <span class="font-14 color-gray-dark">{{ $t('label.no_resources_found') }}</span>
          </div>
        </template>
      </el-menu>
      <el-menu
        v-if="sidebarActive === 'privacy-policy'"
        :collapse="isCollapse"
        :router="true"
        default-active="privacy-policy1"
        class="el-no-submenu"
        background-color="#F5FCFF"
        active-text-color="#1685C7">
        <el-divider class="mt-0 mb-0"></el-divider>
        <el-menu-item
          v-for="(item, key) in filterMenuPrivacy"
          :key="key"
          :route="item.url"
          :index="item.index"
          class="sub-menu-container">
          <template #title>
            <span class="main-sidebar__sub-menu-title">{{ item.name }}</span>
          </template>
        </el-menu-item>
      </el-menu>
    </el-scrollbar>
  </el-aside>
</template>

<script setup>
import { dataDocumentation } from '@/api/endpoints/collection'
import { computed, ref } from 'vue'
import { Search } from '@element-plus/icons-vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const search = ref('')
const searchPrivacy = ref('')
const resultMenu = ref([])
const isCollapse = ref(false)
const route = useRoute()
const dataMenuDocumentation = ref([{
  index: 'overview',
  name: 'Overview',
  sub_menu: [{
    index: 'introduction',
    sub_name: 'Introduction',
    url: '/documentation/introduction'
  }, {
    index: 'dev',
    sub_name: 'Developer Guide',
    url: '/documentation/developer-guide'
  }, {
    index: 'api-cals',
    sub_name: 'Api Call Flows',
    url: '/documentation/api-call-flow'
  }]
}])
const dataMenuWebhook = ref([{
  index: 'webhook',
  name: 'Webhook',
  sub_menu: [{
    index: '/open-order-update-status',
    sub_name: 'Open Order Update Status',
    url: '/documentation/webhook/open-order-update-status'
  }, {
    index: 'sales-return-update-status',
    sub_name: 'Sales Return Update Status',
    url: '/documentation/webhook/sales-return-update-status'
  }, {
    index: 'open-purchase-update-status',
    sub_name: 'Open Purchase Update Status',
    url: '/documentation/webhook/open-purchase-update-status'
  }, {
    index: 'purchase-return-update-status',
    sub_name: 'Purchase Return Update Status',
    url: '/documentation/webhook/purchase-return-update-status'
  }]
}])
const dataMenuConsole = ref([{
  index: 'app-management',
  name: 'App Management',
  sub_menu: [{
    index: 'intro1',
    sub_name: 'App List',
    url: '/console/app-list'
  }]
}])
const dataMenuPrivacy = ref([{
  index: 'privacy-policy1',
  name: t('sidebar.privacy_policy'),
  url: '/privacy-policy#1'
}, {
  index: 'privacy-policy2',
  name: t('sidebar.information'),
  url: '/privacy-policy#2'
}, {
  index: 'privacy-policy3',
  name: t('sidebar.security'),
  url: '/privacy-policy#3'
}, {
  index: 'privacy-policy4',
  name: t('sidebar.disclosure'),
  url: '/privacy-policy#4'
}, {
  index: 'privacy-policy5',
  name: t('sidebar.cookies'),
  url: '/privacy-policy#5'
}, {
  index: 'privacy-policy6',
  name: t('sidebar.google_analytics'),
  url: '/privacy-policy#6'
}, {
  index: 'privacy-policy7',
  name: t('sidebar.changes_privacy'),
  url: '/privacy-policy#7'
}, {
  index: 'privacy-policy8',
  name: t('sidebar.data_deletion'),
  url: '/privacy-policy#8'
}])

dataMenuDocumentation.value.push(...dataDocumentation.value)
const filterMenu = computed(() => {
  return dataMenuDocumentation.value.filter((menu) => {
    return menu.sub_menu.some(item => {
      return item.sub_name.toLowerCase().includes(search.value.toLowerCase())
    })
  })
})
const filterMenuPrivacy = computed(() => {
  return dataMenuPrivacy.value.filter((menu) => {
    return menu.name.toLowerCase().includes(searchPrivacy.value.toLowerCase())
  })
})
const activeMenu = computed(() => {
  filterMenu.value.forEach(item => {
    resultMenu.value.push(item.index)
  })
  return resultMenu.value
})
const sidebarActive = computed(() => {
  const url = route.path.split('/')
  return url[1]
})
</script>
